/**
 * @file Renders a photo carousel, or nothing when there are no photos.
 */
import { Carousel, Image } from "antd";

import { getResizedImageUrl } from "@components/Storage";

import Arrow from "./Arrow";

import "./Slider.css";

export const DEFAULT_SIZE: [number, number] = [ 1040, 480 ];

export type SliderPhoto = {
  name?: string;
  path: string;
};

type Props = {
  size?: [number, number];
  photos: SliderPhoto[];
};

/**
 * Renders the given photos in a carousel, with navigation arrows shown
 * only when there is more than one photo.
 */
const Slider = ({
  size = DEFAULT_SIZE,
  photos,
}: Props): JSX.Element | null => {
  const hasPhotos = photos.length > 0;

  if (!hasPhotos) {
    return null;
  }

  const hasMultiplePhotos = photos.length > 1;

  const [ width, height ] = size;

  return (
    <Carousel
      arrows={hasMultiplePhotos}
      nextArrow={<Arrow />}
      prevArrow={<Arrow />}
    >
      {
        photos.map(({ name, path }, index) => (
          <Image
            key={index}
            alt={name}
            src={getResizedImageUrl(path, width * 2, height * 2)}
            width="100%"
            preview={false}
          />
        ))
      }
    </Carousel>
  );
};

export default Slider;
